<template>
  <div>
    <div>
      <a-select v-model="nowTime" @change="selectChange" size="small" style="width: 90px;margin-left:10px;">
        <a-select-option v-for="(item, index) in queryList" :key="index" :value="item.value">
          {{ item.label }}
        </a-select-option>
      </a-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeQuery',
  data () {
    return {
      nowTime: 1,
      queryList: [
        {
          label: '本月',
          value: 1
        },
        {
          label: '上月',
          value: 2
        },
        {
          label: '一季度',
          value: 3
        },
        {
          label: '二季度',
          value: 4
        },
        {
          label: '三季度',
          value: 5
        },
        {
          label: '四季度',
          value: 6
        },
        {
          label: '本年',
          value: 7
        },
        {
          label: '上年',
          value: 8
        }
      ]
    }
  },
  methods: {
    selectChange (e) {
      this.nowTime = e
      this.$emit('select', e)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/homeComponents/queryView.vue